import * as React from 'react';

const FOOTER_CSS_ID = 'ovc-new-global-style';
const FOOTER_CSS_HREF = '/css/new_global_style.css';

const ASSETS = {
	logoSrc:
		'https://cdn.prod.website-files.com/68503ae3ed503a1573553872/693bc9f5a16ec37e0da259c7_Layer_1.png',
};
const LOGO_SRC_SET = [
	'https://cdn.prod.website-files.com/68503ae3ed503a1573553872/693bc9f5a16ec37e0da259c7_Layer_1-p-500.png 500w',
	'https://cdn.prod.website-files.com/68503ae3ed503a1573553872/693bc9f5a16ec37e0da259c7_Layer_1.png 978w',
].join(', ');

type FooterLinkItem = {
	label: string;
	href: string;
	newTab?: boolean;
};

type FooterSection = {
	title: string;
	links: Array<FooterLinkItem>;
};

const TRAVELER_LINKS: Array<FooterLinkItem> = [
	{ label: 'Solo Travelers Club', href: 'https://www.onlinevacationcenter.com/solo-travelers-club' },
	{
		label: 'Group Getaways',
		href: 'https://travel.onlinevacationcenter.com/acton/media/12605/groupgetaways',
		newTab: true,
	},
	{ label: 'Personal Vacation Managers', href: 'https://www.onlinevacationcenter.com/managers' },
	{ label: 'Travel Insurance', href: 'https://www.onlinevacationcenter.com/travel-insurance' },
	{ label: 'Passport Requirements', href: 'https://www.onlinevacationcenter.com/passport-requirements' },
	{
		label: 'Shore Excursions',
		href: 'https://www.shoreexcursionsgroup.com/?ID=34&source=header',
		newTab: true,
	},
	{ label: 'Customer Support', href: 'https://www.onlinevacationcenter.com/contact-us' },
	{ label: 'Travel Blog', href: 'https://blog.onlinevacationcenter.com/', newTab: true },
	{ label: 'FAQ', href: 'https://www.onlinevacationcenter.com/faqs' },
	{
		label: 'Enter Contest',
		href:
			'https://www.sigtn.com/SigNet/index.cfm/EMC/SignupForm/SignupForm/Index?view=sweepstakesLanding&agencyID=2954'
			+ '&UTP=consumer&CFID=465926046&CFTOKEN=74273312',
		newTab: true,
	},
	{ label: 'Request A Quote', href: 'https://www.onlinevacationcenter.com/request-a-quote' },
];

const OVC_LINKS: Array<FooterLinkItem> = [
	{ label: 'About us', href: 'https://www.onlinevacationcenter.com/why-ovc' },
	{ label: 'Careers', href: 'https://www.onlinevacationcenter.com/careers' },
	{ label: 'Investors', href: 'https://www.onlinevacationcenter.com/investors' },
	{ label: 'Privacy Policy', href: 'https://www.onlinevacationcenter.com/privacy-policy' },
	{ label: 'Reviews', href: 'https://www.onlinevacationcenter.com/reviews' },
	{ label: 'Terms of Use', href: 'https://www.onlinevacationcenter.com/general-terms' },
];

const SOCIAL_LINKS: Array<FooterLinkItem> = [
	{ label: 'Facebook', href: 'https://web.facebook.com/OnlineVacationCenter', newTab: true },
	{ label: 'Instagram', href: 'https://www.instagram.com/onlinevacationcenter/', newTab: true },
	{ label: 'YouTube', href: 'https://www.youtube.com/@Onlinevacationcenter', newTab: true },
	{ label: 'Pinterest', href: 'https://ar.pinterest.com/vacationmanager/', newTab: true },
	{ label: 'LinkedIn', href: 'https://www.linkedin.com/company/online-vacation-center/', newTab: true },
	{ label: 'X', href: 'https://x.com/VacationManager', newTab: true },
];

const SECTIONS: Array<FooterSection> = [
	{ title: 'For travelers', links: TRAVELER_LINKS },
	{ title: 'Online Vacation Center', links: OVC_LINKS },
	{ title: 'Social media', links: SOCIAL_LINKS },
];

const ensureFooterStyles = () => {
	if (!document.getElementById(FOOTER_CSS_ID)) {
		const css = document.createElement('link');
		css.id = FOOTER_CSS_ID;
		css.rel = 'stylesheet';
		css.type = 'text/css';
		css.href = FOOTER_CSS_HREF;
		document.head.appendChild(css);
	}
};

const renderLink = (item: FooterLinkItem) => (
	<div key={item.label}>
		<div className="padding-small">
			<div className="text-size-regular">
				<div className="text-weight-medium">
					<a
						href={item.href}
						target={item.newTab ? '_blank' : undefined}
						rel={item.newTab ? 'noreferrer' : undefined}
						className="footer_link"
					>
						{item.label}
					</a>
				</div>
			</div>
		</div>
	</div>
);

export const Footer: React.FC = () => {
	React.useEffect(() => {
		ensureFooterStyles();
	}, []);

	return (
		<>
			<div className="global_divider" />
			<footer className="footer_component ovc-safe-footer">
				<div className="container-largex">
					<div className="padding-global">
						<div className="padding-section-medium">
							<div className="container-large">
								<div className="footer-container">
									<div className="footer_newsletter">
										<div className="div-block-6">
											<div className="max-width-medium" />
										</div>
									</div>
									<div className="global_divider" />
									<div className="footer_links-container">
										{SECTIONS.map((section) => (
											<div key={section.title} className="category-container">
												<div className="text-size-small">
													<div className="text-weight-semibold">
														<p style={{ color: '#000000' }}>{section.title}</p>
													</div>
												</div>
												<div className="category-links">
													{section.links.map((item) => renderLink(item))}
												</div>
											</div>
										))}
									</div>
									<div className="global_divider" />
									<div className="footer_bottom-container">
										<div className="logotype-container">
											<img
												src={ASSETS.logoSrc}
												loading="lazy"
												width={79}
												sizes="(max-width: 479px) 100vw, 79px"
												alt="Online Vacation Center"
												srcSet={LOGO_SRC_SET}
												className="image-24 w-variant-99c3a15f-1d1d-33fa-ac9b-25394975ef81 dark-logo"
											/>
										</div>
										<div>
											<div className="text-size-small">
												<div className="text-weight-medium">
													<div className="text-align-center">
														<p className="paragraph-3">
															© {new Date().getFullYear()} Online Vacation Center. All rights reserved.
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
			<div className="global_divider" />
		</>
	);
};
